import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Modal, Row, Select, Space } from "antd"
import { DeleteOutlined } from '@ant-design/icons'
import TextArea from "antd/lib/input/TextArea"
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import _ from 'lodash'

const { Option } = Select

interface formRow {
    check_in_id: string | undefined // 入住id，“入住客户管理-按条件查询列表（分页）”接口返回的check_in_id字段
    complaint_time: string | undefined // 客诉时间
    handle_department_list_id: string | undefined // 处理部门id，“全局-查询门店下的一级部门”接口返回的department_id字段，请求参数store_id已经在“入住客户管理-查看详情-查询客户基本信息”接口里返回了
    complaint_type_id: string | undefined // 客诉类型id，“全局-查询投诉类型列表”接口返回的complaint_type_id字段
    complaint_content: string | undefined // 客诉内容
}

interface ct {
    "complaint_type_id": string,
    "complaint_type_name": string
}

interface dm {
    "department_id": string,
    "department_name": string
}

interface Prop {
    storeID?: string
}

interface Client {
    check_in_id: string // 入住id
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期（预计入住时间）
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    deal_item_name: string // 签单套餐名称
    check_in_total_days: number // 入住总天数，整数类型
    check_in_already_days: number // 已入住天数，整数类型
    check_in_left_days: number // 剩余天数，整数类型
    item_days: number // 套餐入住天数，整数类型
    gift_days: number // 赠送天数，整数类型
    deal_records_remark: string // 签单备注
    store_id: string // 签单门店id
    deal_prov_pic_list: string // 合同凭证图片
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()
    const [clientData, setClientData] = useState<Client>()

    const [visible, setVisible] = useState<boolean>(false)
    const [complaintTypes, setComplaintTypes] = useState<ct[]>([])
    const [dm, setDm] = useState<dm[]>([])

    let formRow: formRow = {
        check_in_id: undefined, // 入住id，“入住客户管理-按条件查询列表（分页）”接口返回的check_in_id字段
        complaint_time: undefined, // 客诉时间
        handle_department_list_id: undefined, // 处理部门id，“全局-查询门店下的一级部门”接口返回的department_id字段，请求参数store_id已经在“入住客户管理-查看详情-查询客户基本信息”接口里返回了
        complaint_type_id: undefined, // 客诉类型id，“全局-查询投诉类型列表”接口返回的complaint_type_id字段
        complaint_content: undefined, // 客诉内容
    }

    const [formData, setFormData] = useState<formRow[]>([{
        check_in_id: undefined, // 入住id，“入住客户管理-按条件查询列表（分页）”接口返回的check_in_id字段
        complaint_time: undefined, // 客诉时间
        handle_department_list_id: undefined, // 处理部门id，“全局-查询门店下的一级部门”接口返回的department_id字段，请求参数store_id已经在“入住客户管理-查看详情-查询客户基本信息”接口里返回了
        complaint_type_id: undefined, // 客诉类型id，“全局-查询投诉类型列表”接口返回的complaint_type_id字段
        complaint_content: undefined, // 客诉内容
    }])

    useEffect(() => {
        getClientInfo()

        baseAxiosNoInfo('/global/complaint_type_list').then((res: any) => {
            res && setComplaintTypes(res)
        })

        baseAxiosNoInfo('/global/first_level_dep_of_store', {
            params: {
                check_in_id: param.id
            }

        }).then((res: any) => {
            res && setDm(res)
        })
    }, [])

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/base_info', {
            params: {
                check_in_id: param.id
            }

        }).then((res: any) => {
            if (res) {
                setClientData(res)
            }

        })
    }

    const addMoreRow = () => {
        setFormData([...formData, formRow])
    }

    const deleteRow = (index: number) => {
        if (formData.length > 1) {
            let reciveD = _.cloneDeep(formData)
            reciveD.splice(index, 1)

            setFormData(reciveD)
        }
    }

    const handleChange = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(formData)
        reciveD[index][attr] = value

        setFormData(reciveD)
    }


    const onFinish = () => {
        baseAxiosComplete.post('/keeper/check_in/detail/add_customer_complaint', {
            check_in_id: param.id,
            complain_list: formData

        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
            }
        })
    }

    return <Fragment>
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>添加客诉</Button>

        <Modal title="添加客诉" width={1000} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Row>
                <Col span={6}>
                    <div>
                        <Space>
                            <p>客人姓名：</p>
                            <p>{clientData?.check_in_user_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>手机号码：</p>
                            <p>{clientData?.check_in_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>怀孕时期：</p>
                            <p>{clientData?.preg_status_desc}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预产期：</p>
                            <p>{clientData?.expect_born_day}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>实际入住日期：</p>
                            <p>{clientData?.check_in_time}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预计出所日期：</p>
                            <p>{clientData?.check_out_time_init}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>实际出所日期：</p>
                            <p>{clientData?.check_out_time_finally}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>紧急联系人：</p>
                            <p>{clientData?.emergency_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>紧急联系人手机：</p>
                            <p>{clientData?.emergency_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>陪护人：</p>
                            <p>{clientData?.accompany_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>陪护人手机：</p>
                            <p>{clientData?.accompany_phone}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>预住总天数：</p>
                            <p>{clientData?.check_in_total_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>已入住天数：</p>
                            <p>{clientData?.check_in_already_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>剩余天数：</p>
                            <p>{clientData?.check_in_left_days}</p>
                        </Space>
                    </div>
                </Col>
            </Row>

            {formData.map((el, index: number) => <Row gutter={8} justify="space-around" style={{ marginTop: 20, marginBottom: 8, userSelect: 'none' }}>
                <Col span={3}>
                    <Select placeholder="责任部门" value={el.handle_department_list_id} style={{ width: '120px' }} onChange={(v: string) => {
                        handleChange(index, 'handle_department_list_id', v)
                    }}>
                        {dm.map((el: dm) => <Option value={el.department_id} key={el.department_name}>{el.department_name}</Option>)}
                    </Select>
                </Col>

                <Col span={3}>
                    <DatePicker showTime placeholder="客诉日期" onChange={(v: any) => {
                        handleChange(index, 'complaint_time', v.format('YYYY-MM-DD HH:mm:ss'))
                    }} />
                </Col>

                <Col span={3}>
                    <Select placeholder="客诉类型" virtual={false} value={el.complaint_type_id} style={{ width: '100%' }} onChange={(v: string) => {
                        handleChange(index, 'complaint_type_id', v)
                    }}>
                        {complaintTypes.map((el: ct) => <Option value={el.complaint_type_id} key={el.complaint_type_name}>{el.complaint_type_name}</Option>)}
                    </Select>
                </Col>

                <Col span={7}>
                    <TextArea placeholder="客诉内容" value={el.complaint_content} style={{ height: '120px' }} onChange={(e) => {
                        handleChange(index, 'complaint_content', e.target.value)
                    }} />
                </Col>

                <Col span={1} style={{ paddingTop: 4 }}>
                    <DeleteOutlined onClick={() => {
                        deleteRow(index)
                    }} style={{ cursor: 'pointer' }} />
                </Col>
            </Row>)}

            <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加客诉</Button>
        </Modal>
    </Fragment>
}